<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{
  error: NuxtError
}>()

const { locale } = await useInitApp()

// Provide proper error meta based on status
useSeoMeta({
  title: () => props.error.statusCode === 404 ? 'Pagina niet gevonden' : 'Er is een fout opgetreden',
  description: () => props.error.statusCode === 404
    ? 'De pagina die u zoekt bestaat niet.'
    : 'Er is een technische fout opgetreden. Probeer het later opnieuw.',
  robots: 'noindex',
})
</script>

<template>
  <UApp :locale="locale">
    <ApplicationHeaderNavigation />
    <UMain>
      <UError :error="props.error" />
    </UMain>
  </UApp>
</template>
